import { Injectable } from '@angular/core';
import { ApiResponseDefault } from '@core/interfaces/request-response/api.dto';
import { ILoginDTO } from '@core/interfaces/request-response/login.dto.interface';
import { environment } from '@env/environment';
import { BaseHttpService } from '@shared/services/base-http.service';

@Injectable({
  providedIn: 'root',
})
export class AuthApiService extends BaseHttpService {
  login(email: string, contra: string, ruc: string) {
    return this.withLoader(
      this.httpClient.post<ILoginDTO>(
        `${environment.apiUrl}${environment.apiPreFix}/auth/v2/login`,
        { email, contra, ruc },
        { withCredentials: true },
      ),
    );
  }

  refresh() {
    return this.withLoader(
      this.httpClient.post<ILoginDTO>(
        `${environment.apiUrl}${environment.apiPreFix}/auth/v2/refresh-token`,
        {},
        { withCredentials: true },
      ),
    );
  }

  logout() {
    return this.withLoader(
      this.httpClient.post(
        `${environment.apiUrl}${environment.apiPreFix}/auth/v2/logout`,
        {},
        { withCredentials: true },
      ),
    );
  }

  recuperar(email: string, ruc: string) {
    return this.withLoader(
      this.httpClient.post(
        `${environment.apiUrl}${environment.apiPreFix}/auth/v2/recuperar-cuenta`,
        { email, ruc },
      ),
    );
  }
  resetPassword(email: string, token: string, nuevaContrasena: string) {
    return this.withLoader(
      this.httpClient.post<ApiResponseDefault>(
        `${environment.apiUrl}${environment.apiPreFix}/auth/v2/reset-password`,
        {
          email,
          token,
          nuevaContrasena,
        },
      ),
    );
  }
}
